import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import DefaultPage from "../DefaultPage/DefaultPage.js";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import "./PersonalDataPage.css";
import Document from "../DocumentsPage/Document.js";
import Loader from "../../components/Loader.js";

const PersonalDataPage = () => {
  //fetch stranky
  const { loading, error, data } = useFetch(
    `${config.api}/api/personal-informations-page?populate=*`
  );

  // možné stavy při/po fetchi
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání stránky" />;

  if (!data || !data.data) return <DefaultPage message="Žádné data" />;

  //? test
  //? console.log("Aktuality", data);

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background p-4 p-md-5 pt-md-4">
          {data.data.documents !== null && (
            <>
              <div className="news-doc-container justify-content-center mb-4">
                <div className="news-doc">
                  <Document
                    name={data.data.documents.name}
                    fileUrl={data.data.documents.url}
                  />
                </div>
              </div>
            </>
          )}
          <BlocksRenderer
            content={Array.isArray(data?.data?.text) ? data.data.text : []}
            blocks={{
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText}
                  className="blocks-renderer-img"
                />
              ),
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="blocks-renderer-ul">{children}</ul>
                ) : (
                  <ol className="blocks-renderer-ol">{children}</ol>
                ),
            }}
          ></BlocksRenderer>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default PersonalDataPage;
